import { render } from "./SpmKpi.vue?vue&type=template&id=3ac37a48&scoped=true"
import script from "./SpmKpi.vue?vue&type=script&lang=ts"
export * from "./SpmKpi.vue?vue&type=script&lang=ts"

import "./SpmKpi.vue?vue&type=style&index=0&id=3ac37a48&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3ac37a48"

export default script